export type NationalityOption = {
  id: number;
  name: string;
};

export const nationalityOptions: NationalityOption[] = [
  { id: 1, name: "Afghan" },
  { id: 2, name: "Albanian" },
  { id: 3, name: "Algerian" },
  { id: 4, name: "American" },
  { id: 5, name: "Andorran" },
  { id: 6, name: "Angolan" },
  { id: 7, name: "Antiguans" },
  { id: 8, name: "Argentinean" },
  { id: 9, name: "Armenian" },
  { id: 10, name: "Australian" },
  { id: 11, name: "Austrian" },
  { id: 12, name: "Azerbaijani" },
  { id: 13, name: "Bahamian" },
  { id: 14, name: "Bahraini" },
  { id: 15, name: "Bangladeshi" },
  { id: 16, name: "Barbadian" },
  { id: 17, name: "Barbudans" },
  { id: 18, name: "Batswana" },
  { id: 19, name: "Belarusian" },
  { id: 20, name: "Belgian" },
  { id: 21, name: "Belizean" },
  { id: 22, name: "Beninese" },
  { id: 23, name: "Bhutanese" },
  { id: 24, name: "Bolivian" },
  { id: 25, name: "Bosnian" },
  { id: 26, name: "Brazilian" },
  { id: 27, name: "British" },
  { id: 28, name: "Bruneian" },
  { id: 29, name: "Bulgarian" },
  { id: 30, name: "Burkinabe" },
  { id: 31, name: "Burmese" },
  { id: 32, name: "Burundian" },
  { id: 33, name: "Cambodian" },
  { id: 34, name: "Cameroonian" },
  { id: 35, name: "Canadian" },
  { id: 36, name: "Cape Verdean" },
  { id: 37, name: "Central African" },
  { id: 38, name: "Chadian" },
  { id: 39, name: "Chilean" },
  { id: 40, name: "Chinese" },
  { id: 41, name: "Colombian" },
  { id: 42, name: "Comoran" },
  { id: 43, name: "Congolese" },
  { id: 44, name: "Costa Rican" },
  { id: 45, name: "Croatian" },
  { id: 46, name: "Cuban" },
  { id: 47, name: "Cypriot" },
  { id: 48, name: "Czech" },
  { id: 49, name: "Danish" },
  { id: 50, name: "Djibouti" },
  { id: 51, name: "Dominican" },
  { id: 52, name: "Dutch" },
  { id: 53, name: "East Timorese" },
  { id: 54, name: "Ecuadorean" },
  { id: 55, name: "Egyptian" },
  { id: 56, name: "Emirian" },
  { id: 57, name: "Equatorial Guinean" },
  { id: 58, name: "Eritrean" },
  { id: 59, name: "Estonian" },
  { id: 60, name: "Ethiopian" },
  { id: 61, name: "Fijian" },
  { id: 62, name: "Filipino" },
  { id: 63, name: "Finnish" },
  { id: 64, name: "French" },
  { id: 65, name: "Gabonese" },
  { id: 66, name: "Gambian" },
  { id: 67, name: "Georgian" },
  { id: 68, name: "German" },
  { id: 69, name: "Ghanaian" },
  { id: 70, name: "Greek" },
  { id: 71, name: "Grenadian" },
  { id: 72, name: "Guatemalan" },
  { id: 73, name: "Guinea-Bissauan" },
  { id: 74, name: "Guinean" },
  { id: 75, name: "Guyanese" },
  { id: 76, name: "Haitian" },
  { id: 77, name: "Herzegovinian" },
  { id: 78, name: "Honduran" },
  { id: 79, name: "Hungarian" },
  { id: 80, name: "Icelander" },
  { id: 81, name: "Indian" },
  { id: 82, name: "Indonesian" },
  { id: 83, name: "Iranian" },
  { id: 84, name: "Iraqi" },
  { id: 85, name: "Irish" },
  { id: 86, name: "Israeli" },
  { id: 87, name: "Italian" },
  { id: 88, name: "Ivorian" },
  { id: 89, name: "Jamaican" },
  { id: 91, name: "Malawian" },
  { id: 92, name: "Malaysian" },
  { id: 93, name: "Maldivan" },
  { id: 94, name: "Malian" },
  { id: 95, name: "Maltese" },
  { id: 96, name: "Marshallese" },
  { id: 97, name: "Mauritanian" },
  { id: 98, name: "Mauritian" },
  { id: 99, name: "Mexican" },
  { id: 100, name: "Micronesian" },
  { id: 101, name: "Moldovan" },
  { id: 102, name: "Monacan" },
  { id: 103, name: "Mongolian" },
  { id: 104, name: "Moroccan" },
  { id: 105, name: "Mosotho" },
  { id: 106, name: "Motswana" },
  { id: 107, name: "Mozambican" },
  { id: 108, name: "Namibian" },
  { id: 109, name: "Nauruan" },
  { id: 110, name: "Nepalese" },
  { id: 111, name: "Netherlander" },
  { id: 112, name: "New Zealander" },
  { id: 113, name: "Ni-Vanuatu" },
  { id: 114, name: "Nicaraguan" },
  { id: 115, name: "Nigerian" },
  { id: 116, name: "Nigerien" },
  { id: 117, name: "North Korean" },
  { id: 118, name: "Northern Irish" },
  { id: 119, name: "Norwegian" },
  { id: 120, name: "Omani" },
  { id: 121, name: "Pakistani" },
  { id: 122, name: "Palauan" },
  { id: 123, name: "Panamanian" },
  { id: 124, name: "Papua New Guinean" },
  { id: 125, name: "Paraguayan" },
  { id: 126, name: "Peruvian" },
  { id: 127, name: "Polish" },
  { id: 128, name: "Portuguese" },
  { id: 129, name: "Qatari" },
  { id: 130, name: "Romanian" },
  { id: 131, name: "Russian" },
  { id: 132, name: "Rwandan" },
  { id: 133, name: "Saint Lucian" },
  { id: 134, name: "Salvadoran" },
  { id: 135, name: "Samoan" },
  { id: 136, name: "San Marinese" },
  { id: 137, name: "Sao Tomean" },
  { id: 138, name: "Saudi" },
  { id: 139, name: "Scottish" },
  { id: 140, name: "Senegalese" },
  { id: 141, name: "Serbian" },
  { id: 142, name: "Seychellois" },
  { id: 143, name: "Sierra Leonean" },
  { id: 144, name: "Singaporean" },
  { id: 145, name: "Slovakian" },
  { id: 146, name: "Slovenian" },
  { id: 147, name: "Solomon Islander" },
  { id: 148, name: "Somali" },
  { id: 149, name: "South African" },
  { id: 150, name: "South Korean" },
  { id: 151, name: "Spanish" },
  { id: 152, name: "Sri Lankan" },
  { id: 153, name: "Sudanese" },
  { id: 154, name: "Surinamer" },
  { id: 155, name: "Swazi" },
  { id: 156, name: "Swedish" },
  { id: 157, name: "Swiss" },
  { id: 158, name: "Syrian" },
  { id: 159, name: "Taiwanese" },
  { id: 160, name: "Tajik" },
  { id: 161, name: "Tanzanian" },
  { id: 162, name: "Thai" },
  { id: 163, name: "Togolese" },
  { id: 164, name: "Tongan" },
  { id: 165, name: "Trinidadian or Tobagonian" },
  { id: 166, name: "Tunisian" },
  { id: 167, name: "Turkish" },
  { id: 168, name: "Tuvaluan" },
  { id: 169, name: "Ugandan" },
  { id: 170, name: "Ukrainian" },
  { id: 171, name: "Uruguayan" },
  { id: 172, name: "Uzbekistani" },
  { id: 173, name: "Venezuelan" },
  { id: 174, name: "Vietnamese" },
  { id: 175, name: "Welsh" },
  { id: 176, name: "Yemenite" },
  { id: 177, name: "Zambian" },
  { id: 178, name: "Zimbabwean" },
  { id: 179, name: "Lithuanian" },
  { id: 180, name: "Latvian" },
  { id: 181, name: "Lebanese" },
  { id: 182, name: "Japanese" },
  { id: 183, name: "English" },
  { id: 184, name: "Jordanian" },
  { id: 185, name: "Kazakhstan" },
  { id: 186, name: "Kenyan" },
  { id: 187, name: "Macedonian" },
  { id: 188, name: "Montenegrin" },
  { id: 189, name: "Luxembourgish" },
  { id: 190, name: "Chechen" },
  { id: 191, name: "Palestinian" },
  { id: 192, name: "Liberian" },
  { id: 193, name: "South Sudanese" },
];
